// extracted by mini-css-extract-plugin
module.exports = {"root":"IconNoCheck_root__3VNEd"};